import { style } from "@vanilla-extract/css";
import { primitiveTokens } from "../../theme/ThemeTokens.css";

export const wrapper = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  height: "100%"
});

export const toggle = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "50%",
  minWidth: "max-content",
  height: "100%",
  border: "none",
  background: "none",
  margin: 0,
  cursor: "pointer",
  padding: `0 ${primitiveTokens.sizing["7x"]}`
});

export const dot = style({
  display: "inline-block",
  width: "14px",
  height: "14px",
  borderRadius: "50%",
  flexShrink: 0
});

export const dotActive = style({
  backgroundColor: primitiveTokens.colors.green[500]
});

export const dotInactive = style({
  backgroundColor: primitiveTokens.colors.red[500]
});

export const dotMixed = style({
  backgroundColor: primitiveTokens.colors.neutral[400]
});

export const dotUnknown = style({
  backgroundColor: primitiveTokens.colors.neutral[300]
});
